var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.socialList)?_c('ul',{staticClass:"social-icon"},_vm._l((_vm.socialList),function(social,i){return _c('li',{key:i},[_c('a',{attrs:{"href":social.url,"target":"_blank"}},[_c('i',{staticClass:"fab",class:social.icon})])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }